import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzEaster80 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_EASTER_80: Record<
  Exclude<PageIdWoofzEaster80, PageIdWoofzEaster80.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_EASTER_80]: {
    id: PageId.SUBSCRIPTIONS_EASTER_80,
  },
  [PageId.CHAT_UPSELL_EASTER_80]: {
    id: PageId.CHAT_UPSELL_EASTER_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_EASTER_80]: {
    id: PageId.UPSELL_EASTER_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_EASTER_80]: {
    id: PageId.DOWNLOAD_EASTER_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
